import { z } from 'zod'

export const startTmaParamsSchema = z.object({
  inviterId: z.string().optional(),
  navigation: z
    .object({
      page: z.literal('createPrivateTable'),
    })
    .or(
      z.object({
        page: z.literal('rewards'),
      }),
    )
    .or(
      z.object({
        page: z.literal('table'),
        params: z.object({
          code: z.string(),
          password: z.string().optional(),
        }),
      }),
    )
    .optional(),
  utm: z
    .object({
      utm_source: z.string(),
    })
    .optional(),
})
